
import React from 'react'
import { Icon, Select, Switch, Button } from 'antd'
import './index.scss'

export default ({
  roles, acls,
  userRole, selectedAcl,
  getPermissions, toggleAclEnabled,
  changeUserRole, user={role:{}}
 }) => (
    <div className='permission-list'>
      <div className='head'>
        <h3>
          <Icon type='lock' /> Permissions
      </h3>
        {roles && user.role.title !== 'Owner' &&
          <Select
            value={userRole} dropdownMatchSelectWidth={false}
            onSelect={changeUserRole} >
            {roles.map((role, index) =>
              <Select.Option
                key={index} value={String(role.id)}>
                {role.title}
              </Select.Option>
            )}
          </Select>
        }
      </div>
      <div className='body'>
        {acls.map((acl, index) =>
          <PermissionItem
            key={index} {...acl } selectedAcl={selectedAcl}
            getPermissions={getPermissions} toggleAclEnabled={toggleAclEnabled}
          />)}
      </div>
    </div>
  )

const PermissionItem = ({
  id, service, selectedAcl,
  enabled, has_permissions,
  getPermissions, toggleAclEnabled
}) => (
    <div className='permission-item'>
      <Button
        type='primary' shape='circle' loading={id === selectedAcl}
        icon='setting' disabled={!has_permissions}
        onClick={getPermissions.bind(null, id)} />
      <p>{service}</p>
      <Switch
        checked={enabled}
        onChange={toggleAclEnabled.bind(null, id, !enabled)} />
    </div>
  )
